import type { SelectionExtensionPluginOptions } from '@atlaskit/editor-plugin-selection-extension';

import { useJiraWorkCreateSelectionExtension } from '@confluence/jira-work-create-extension';
import { fg } from '@confluence/feature-gating';
import type { PageMode } from '@confluence/issue-create-side-panel';
import type { RightSidebarContextType } from '@confluence/page-layout-context';

export const useSelectionExtensionPluginOptions = ({
	isSidePanelOpenRef,
	rightSidebarContextRef,
	pageModeRef,
	hasEditPermissionRef,
}: {
	isSidePanelOpenRef: React.MutableRefObject<boolean>;
	rightSidebarContextRef: React.MutableRefObject<RightSidebarContextType>;
	pageModeRef: React.MutableRefObject<PageMode>;
	hasEditPermissionRef: React.MutableRefObject<boolean>;
}): SelectionExtensionPluginOptions => {
	const jiraWorkCreateSelectionExtension = useJiraWorkCreateSelectionExtension({
		isSidePanelOpenRef,
		rightSidebarContextRef,
		pageModeRef,
		hasEditPermissionRef,
	});

	return {
		extensions: fg('confluence_work_create_edit_and_live_docs_support')
			? { firstParty: [jiraWorkCreateSelectionExtension] }
			: {},
	};
};
